import React from 'react'
import { Dialog } from 'react-weui'
import '../../styles/record/RecordRefund.css'

export default class PhysicalRefundDialog extends React.Component {
  constructor() {
    super()
    this.handleRefundSubmit = this.handleRefundSubmit.bind(this)
    this.state = {
      refundReason: '',
      refundPanel: {
        buttons: [
          {
            type: 'default',
            label: '提交',
            onClick: this.handleRefundSubmit
          },
          {
            type: 'primary',
            label: '取消',
            onClick: this.handleApplyRefundHide.bind(this)
          }
        ]
      }
    }
  }
  handleReasonValue = (e) => {
    this.setState({
      refundReason: e.target.value
    })
  }
  handleApplyRefundHide() {
    this.props.handlePhysicalDialogHide()
  }
  handleRefundSubmit() {
    if(!this.state.refundReason.trim()) {
      return window._wk_toast.show('请填写退款原因', '', 2000)
    }
    this.props.handleRefundSubmit(this.state.refundReason)
  }

  render() {
    const { refundReason, refundPanel } = this.state
    return (
      <div className="physical-refund-dialog">
        <Dialog
          className="refund-reason-dialog"
          type="ios"
          title="该商品是否确认退款？"
          show={true}
          buttons={refundPanel.buttons}>
          <textarea
            className="refund-reason-textarea"
            placeholder="请输入退款原因"
            value={refundReason}
            maxLength={200}
            onChange={this.handleReasonValue}
          />
        </Dialog>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/BoughtPage/PhysicalRefundDialog.js